import { render } from "./ProcessTemplateTypeLabel.vue?vue&type=template&id=8c74964c&scoped=true&ts=true"
import script from "./ProcessTemplateTypeLabel.vue?vue&type=script&lang=ts"
export * from "./ProcessTemplateTypeLabel.vue?vue&type=script&lang=ts"

import "./ProcessTemplateTypeLabel.vue?vue&type=style&index=0&id=8c74964c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8c74964c"]])

export default __exports__